export default {
  "seo.title": "À propos | Bonvi",
  "seo.description": "Découvrez les personnes, l’expérience et les disciplines créatives qui façonnent Bonvi.",
  "number.title": "Nos chiffres",
  "number.copy": "Notre équipe travaille dans plusieurs disciplines, permettant à chaque projet de réunir la combinaison de compétences appropriée.",
  "number.years": "Années d’expérience",
  "number.projects": "Projets livrés",
  "number.markets": "Marchés atteints",
  "strategy.title": "Notre stratégie",
  "strategy.copy": "Bonvi développe la créativité en associant des opérations optimisées par l’IA à la diversité des talents créatifs d’Asie du Sud-Est. Les marques ambitieuses gagnent ainsi en rapidité, en profondeur culturelle et en performance, sans avoir à supporter le coût d’une grande équipe interne.",
  "strategy.ariaLabel": "Nos principes stratégiques",
  "strategy.core.creative": "Croissance",
  "strategy.core.growthAt": "créative",
  "strategy.core.scale": "à grande échelle",
  "strategy.ai": "Moteur créatif optimisé par l’IA",
  "strategy.sea": "Réseau de talents d’Asie du Sud-Est",
  "strategy.global": "Localisation mondiale",
  "strategy.embedded": "Équipes intégrées",
  "strategy.human": "Direction créative humaine",
  "strategy.performance": "Créativité axée sur la performance",
  "creative.title": "Notre créativité",
  "creative.copy1": "Notre équipe travaille dans plusieurs disciplines, permettant à chaque projet de réunir la combinaison de compétences appropriée.",
  "creative.copy2": "Nous ne croyons pas à une créativité universelle. Chaque projet est façonné par son public, sa plateforme et son objectif, en associant réflexion stratégique et expérimentation visuelle pour créer un travail distinctif, pertinent et conçu pour avoir de l’impact.",
  "creative.ariaLabel": "Nos principes créatifs",
  "creative.idea": "L’idée avant tout",
  "creative.medium": "Conçu pour le média",
  "creative.motion": "Le mouvement dans notre ADN",
  "creative.performance": "Une créativité performante",
} as const;
